import { InputForm, Error, SubmitButton } from "components";
import { CommercialDateRangeError, CommercialDateRangeInput } from "modules/user_management/commercial_user/user/state/actionType";

interface Props {
  formData: CommercialDateRangeInput;
  error: CommercialDateRangeError;
  loading: boolean;
  onClose?: () => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement >
  ) => void;
  handleSubmit: React.MouseEventHandler<HTMLButtonElement>;
}
const DateRangeForm: React.FC<Props> = ({
  handleChange,
  handleSubmit,
  error,
  formData,
  loading,
}) => {
  return (
    <>
     <form>
  <div className="flex gap-4 items-end">
    <div>
      <InputForm
        label="From Date"
        id="from_date"
        name="from_date"
        type="datetime-local"
        value={formData.from_date}
        onChange={handleChange}
      />
      {error.from_date && <Error>{error.from_date}</Error>}
    </div>
    <div>
      <InputForm
        label="To Date"
        id="to_date"
        name="to_date"
        type="datetime-local"
        value={formData.to_date}
        onChange={handleChange}
      />
      {error.to_date && <Error>{error.to_date}</Error>}
    </div>
    <div className="pb-3">
      <SubmitButton
        onClick={handleSubmit}
        loading={loading}
        loadingText="Searching..."
      >
        Search
      </SubmitButton>
    </div>
  </div>
</form>

    </>
  );
};
export default DateRangeForm;
